import React from 'react';
import {
  Header,
  SpaceBetween,
  Box,
} from "@cloudscape-design/components";
import { parseCustomerExperience } from '../../../utils/insights/contactSummaryParser';

export default function ConclusionTab({
  selectedCall,
  callDetails,
  t
}) {
  // Parsear CustomerExperience si hay datos
  const parsedData = callDetails?.ConversationAnalytics?.CustomerExperience
    ? parseCustomerExperience(callDetails.ConversationAnalytics.CustomerExperience)
    : null;

  const conclusionTexto = parsedData?.conclusion?.texto;
  
  // Si hay conclusión, dividir en párrafos (separar por puntos seguidos o saltos de línea)
  let conclusionParagraphs = [];
  if (conclusionTexto && typeof conclusionTexto === 'string') {
    // Intentar dividir por saltos de línea primero
    conclusionParagraphs = conclusionTexto.split('\n').map(p => p.trim()).filter(p => p.length > 0);
    
    // Si no hay saltos de línea, intentar dividir por puntos seguidos
    if (conclusionParagraphs.length === 1) {
      conclusionParagraphs = conclusionTexto.split(/\.\s+(?=[A-Z])/).map(p => p.trim()).filter(p => p.length > 0);
    }
    
    // Si aún es un solo párrafo, mantenerlo como está
    if (conclusionParagraphs.length === 0) {
      conclusionParagraphs = [conclusionTexto];
    }
  }

  return (
    <div style={{ width: '100%', minWidth: '350px' }}>
      <Header variant="h3" margin={{ bottom: "m" }}>
        {t("insights.conclusion", { defaultValue: "Conclusión" })}
      </Header>
      <SpaceBetween size="m">
        {conclusionParagraphs.length > 0 ? (
          <Box>
            {conclusionParagraphs.map((paragraph, index) => (
              <Box key={index} margin={{ bottom: index < conclusionParagraphs.length - 1 ? "m" : "none" }}>
                {paragraph}
              </Box>
            ))}
          </Box>
        ) : (
          <Box color="text-body-secondary" variant="p">
            {t("insights.noConclusionAvailable", { defaultValue: "Conclusión no disponible" })}
          </Box>
        )}
      </SpaceBetween>
    </div>
  );
}
